/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query PlatformReadQuery {
    PlatformRead {
      rateSmtpConfiguration,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
